/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ActionTypes } from './action';
import { ITaxRes } from "./types";


const initialState: ITaxRes = {
    items: [],
    totalCount: 0,
    optionList:[]
    
};

const taxReducers = (state: ITaxRes = initialState, action): ITaxRes => {
  switch (action?.type) {
    case ActionTypes.TAX_LIST:{
      const optionList = action?.payload?.items?.map((item: any, index: any)=>{
        return{
          ...item,
          value: item.id,
          label: item.name,
          status: item.active
          
        }
      })
      return {
        ...state,
        ...action?.payload,
        optionList:optionList
      };
    }
    case ActionTypes.ADD_TAX:{
      const items = [];
      items.push(action?.payload);
      state?.items?.map((item, index)=>{
        items.push(item);
      })
      const totalCount = state?.totalCount + 1;
      return {
        ...state,
        items: items,
        totalCount: totalCount,
      };
    }
    case ActionTypes.UPDATE_TAX:{
      const updatedList = state?.items.map(item =>
        item.id === action?.payload.id ? action?.payload : item
      );
      return {
        ...state,
        items: updatedList,
      };
    }
    case ActionTypes.DELETE_TAX:{
      const updatedList = state.items.filter(item => item.id !== action.payload.id);
      const totalCount = state?.totalCount - 1;
      return {
        ...state,
        items: updatedList,
        totalCount: totalCount
      };
    }
    case ActionTypes.ADMIN_LOGOUT:{
      return initialState
    }
    default:
      return state;
  }
};

export default taxReducers;
